import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeColorValue, changeNumberValue, replaceShape } from "../../../../store/model";
import { RootState } from "../../../../store/store";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";
import SelectInput from "../../../Palettes/Propertybar/input/selectInput";
import {
  getColorValue,
  getNumberValue,
} from "../shapeHelper/getSetProperties";
import ShapePalette from "../ShapePalette";
import { converteToPolygon } from "./Line";

export interface LineTypeOption {
  value: number,
  label: string
}
const LineProperyPalette = ({ line }: { line: LineShape }) => {
  const dispatch = useAppDispatch();
  const defaultLineTypeId = useAppSelector((state: RootState) => state.tool.currentLineTypeId)
  const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)
  // const layerList = useAppSelector((state: RootState) => state.tool.layerList)
  // const currentLayer = useAppSelector((state: RootState) => state.tool.currentLayer)

  return (
    <ShapePalette shapeId={line.id}>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={getColorValue(line, "stroke")()}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: line.id,
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeColorValue(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={getNumberValue(line, "strokeWidth")}
          setValue={(number) => {
            const payload = {
              id: line.id,
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeNumberValue(payload));
          }}
        ></NumberInput>
      </div>
      <div>
        <button onClick={ () => {
          dispatch(replaceShape(converteToPolygon(line)))
        }
        }>Convert to Polygon</button>
      </div>
      <div className="property__element">
        <SelectInput
          properyDisplayName="Line type"
          choiseList={lineTypes.map((i) => {
            return { label: i.name, value: i.id }
          })}
          currentValue={ //TODO setget
            line.dashID !== undefined ? {
              label: lineTypes.find(i => i.id === (line.dashID))?.name ?? "",
              value: line.dashID ?? defaultLineTypeId
            } : { label: "Not Found", value: 0 }

          }
          setValue={function (input): void {
            const payload = {
              id: line.id,
              propertyValue: input.value,
              propertyName: "dashID",
            };
            dispatch(changeNumberValue(payload))
          }}
        />
      </div>
    </ShapePalette>

  );
};


const createPropertyPalette = (line: GeometricShape) => {
  return <LineProperyPalette line={line as LineShape} />;
};

export default createPropertyPalette;
